









































































import { Component, Vue } from "vue-property-decorator";
import { ResetPassword, InputError, Utils } from "@/models";
import { userService, loginService } from '../../services';
import { LoginDetail } from '../../models/shared/LoginDetail';
import jwt_decode from 'jwt-decode';

@Component
export default class ResetFirstLoginPage extends Vue {
  private isLoading: boolean = false;
  private data: ResetPassword = new ResetPassword();
  
  private errors: InputError[] = [
    {field: 'password', isError: undefined, message: []},
    {field: 'retypePassword', isError: undefined, message: []},
    {field: 'retypePasswordTrue', isError: undefined, message: []},
  ];

  private created() {
    if(localStorage['x-auth-token']){
      const decoded: any = jwt_decode(localStorage['x-auth-token']);
      if (!decoded.isLogin) {
        this.data.email = decoded.username;
      }
    }
  }

  private clickReset() {
    this.errors.forEach((err) => err.isError = undefined);
    const loginData = {
      username: this.data.email,
      password: this.data.password,
    };
    userService.resetPasswordFirstLogin(this.data).then((res) => {
      loginService.login(loginData).then((data: LoginDetail) => {
        if (data && data.isLoginSuccess) {
          if (data.isLogin) {
            this.$router.push({ name: 'routes.home' });
          }
        }
      })
      
    })
    .catch((error) => {        
        if (error.response.status === 400) {
          Utils.loadFieldErrors(error.response.data.errors, this.errors);
          error.response.data.errors.forEach((err: any) => {
            if (err.field === 'retypePasswordTrue') {
              const inputPassword = this.errors.find((e) => e.field === 'password');
              if (inputPassword) {
                if (inputPassword.isError === undefined) {
                  inputPassword.isError = false;
                  inputPassword.message = [];
                }
                inputPassword.message.push('validation.input.password_similar');
              }
              const inputRetypePassword = this.errors.find((e) => e.field === 'retypePassword');
              if (inputRetypePassword) {
                if (inputRetypePassword.isError === undefined) {
                  inputRetypePassword.isError = false;
                  inputRetypePassword.message = [];
                }
                inputRetypePassword.message.push('validation.input.password_similar');
              }
            }
          });
        }
      })
  }


  private getInputError(field: string): InputError | undefined {
    const inputError = this.errors.find((e) => e.field === field);
    return inputError ? inputError : undefined;
  }
    
  }
